import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import locale from "@aligov/global-locale";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import th_TH from "antd/locale/th_TH";

import App from "./App";
import "./i18n/config";
// import { useTranslation } from "react-i18next";

/**
 * axios全局配置
 * */
import "./axios.config";

const AppWithLocale = () => {
  // 设置antd组件多语言
  const { lang } = locale.getLocale();
  // console.log("****lang", lang, locale.getLocale());
  // const { i18n } = useTranslation();
  const localelng = lang ? lang : enUS;

  return (
    <ConfigProvider locale={localelng}>
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("owtb-root"));

root.render(<AppWithLocale />);
